import React from "react";

function SkeletonBlock({ className = "" }) {
  return (
    <span
      className={`vg-chat-loading-shimmer block rounded-full bg-white/16 ${className}`}
      aria-hidden="true"
    />
  );
}

const EventFeedSkeleton = ({ rows = 6, className = "" }) => (
  <div className={`space-y-[12px] px-[3px] ${className}`} aria-hidden="true">
    {Array.from({ length: rows }).map((_, index) => (
      <div
        key={`event-feed-skeleton-${index}`}
        className="vg-chat-loading-row flex h-[75px] w-full rounded-[16px] bg-black/10 shadow-[0_0_0_1px_rgba(255,255,255,0.34)]"
        style={{ animationDelay: `${index * 70}ms` }}
      >
        <span
          className="vg-chat-loading-shimmer mr-[12px] block h-[75px] w-[75px] shrink-0 rounded-[16px] bg-white/18 shadow-[0_0_0_1px_rgba(255,255,255,0.78)]"
          aria-hidden="true"
        />
        <div className="min-w-0 flex-1 py-[8px] pr-[10px]">
          <div className="flex items-start gap-3">
            <SkeletonBlock className="h-[18px] w-[68%] bg-white/22" />
            <SkeletonBlock className="ml-auto h-[20px] w-[20px] rounded-full bg-white/14" />
          </div>
          <div className="mt-[15px] flex items-center gap-2">
            <SkeletonBlock className="h-[22px] w-[22px] rounded-full bg-white/14" />
            <SkeletonBlock className="h-[22px] w-[22px] rounded-full bg-white/14" />
            <SkeletonBlock className="h-[22px] w-[22px] rounded-full bg-white/14" />
            <SkeletonBlock className="ml-auto h-[14px] w-[84px] bg-white/12" />
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default EventFeedSkeleton;
